export enum SuggestionName {
  LineChart = 'Line chart',
  LineChartSmooth = 'Line chart smooth',
  LineChartGradientColorScheme = 'Line chart with gradient color scheme',
  AreaChart = 'Area chart',
  AreaChartStacked = 'Area chart stacked',
  AreaChartStackedPercent = 'Area chart 100% stacked',
  BarChart = 'Bar chart',
  BarChartGradientColorScheme = 'Bar chart with gradient color scheme',
  BarChartStacked = 'Bar chart stacked',
  BarChartStackedPercent = 'Bar chart 100% stacked',
  BarChartHorizontal = 'Bar chart horizontal',
  BarChartHorizontalStacked = 'Bar chart horizontal stacked',
  BarChartHorizontalStackedPercent = 'Bar chart horizontal 100% stacked',
  Candlestick = 'Candlestick',
  PieChart = 'Pie chart',
  PieChartDonut = 'Pie chart donut',
  Stat = 'Stat',
  StatColoredBackground = 'Stat colored background',
  Gauge = 'Gauge',
  GaugeCircular = 'Circular gauge',
  GaugeNoThresholds = 'Gauge no thresholds',
  BarGaugeBasic = 'Bar gauge basic',
  BarGaugeLCD = 'Bar gauge LCD',
  Table = 'Table',
  StateTimeline = 'State timeline',
  StatusHistory = 'Status history',
  TextPanel = 'Text',
  DashboardList = 'Dashboard list',
  Logs = 'Logs',
  FlameGraph = 'Flame graph',
  Trace = 'Trace',
  NodeGraph = 'Node graph',
}
